// ********* GET SETTINGS ********************************
export const GET_SETTINGS_INITIATED = "GET_SETTINGS_INITIATED";
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_FAILED = "GET_SETTINGS_FAILED";

// ********* UPDATE SETTINGS ******************************
export const UPDATE_SETTINGS_INITIATED = "UPDATE_SETTINGS_INITIATED";
export const UPDATE_SETTINGS_SUCCESS = "UPDATE_SETTINGS_SUCCESS";
export const UPDATE_SETTINGS_FAILED = "UPDATE_SETTINGS_FAILED";
